module.exports = __webpack_public_path__ + "img/logo-text.04fc2812.png";